import type EmberArray from '@ember/array';
import type ArrayProxy from '@ember/array/proxy';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AbilitiesService from 'ember-can/services/abilities';
import type AverageMonthlyVisitorCount from 'garaje/models/average-monthly-visitor-count';
import type GroupModel from 'garaje/models/group';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';

interface LocationOverviewLocationsRouteModelWithGroups {
  groups: EmberArray<GroupModel>;
}

export type LocationOverviewLocationsRouteModel =
  | LocationOverviewLocationsRouteModelWithGroups
  | ArrayProxy<AverageMonthlyVisitorCount>;

export default class LocationOverviewLocationsRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare store: Store;
  @service declare globalOverviewAccess: GlobalOverviewAccessService;

  beforeModel(): void {
    if (!this.globalOverviewAccess.canVisitGlobalLocation) {
      this.router.transitionTo('unauthorized');
    }
  }

  async model(): Promise<LocationOverviewLocationsRouteModel> {
    if (this.abilities.can('manage locations-grouping')) {
      const groups = (await this.store.findAll('group')) as EmberArray<GroupModel>;
      return { groups };
    }
    return this.store.findAll('average-monthly-visitor-count');
  }
}
